// removed by extract-text-webpack-plugin
module.exports = {"pills":"_2dOaZT8Ek_Bw88C3ocULct"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/ContactSearch/SearchInput/ContactPills/ContactPills.css
// module id = 557
// module chunks = 0